import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-eight',
  templateUrl: './home-eight.component.html',
  styleUrls: ['./home-eight.component.scss']
})
export class HomeEightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
